import React from 'react'
import styled from 'styled-components'

import DesktopRankingItem from './desktop/ListItem'
import MobileRankingItem from './mobile/ListItem'
import { MysqlRanksEdge, MysqlSurveyQuestionsEdge } from '../../graphqlTypes'

const Container = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  list-style: none;
`

const DesktopContainer = styled(Container)`
  @media (max-width: ${({ theme }) => theme.mediaQuery.mobile.maxWidth}) {
    display: none;
  }
`

const MobileContainer = styled(Container)`
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    display: none;
  }
`

type Props = {
  ranks: MysqlRanksEdge[]
  surveyQuestions: MysqlSurveyQuestionsEdge[]
}

export default function Ranking({ ranks, surveyQuestions }: Props) {
  const items = ranks.length < 3 ? [ranks[0]] : ranks

  return (
    <React.Fragment>
      <DesktopContainer>
        {items.map(({ node }) => (
          <DesktopRankingItem key={node.id} rank={node} ranks={ranks} surveyQuestions={surveyQuestions} />
        ))}
      </DesktopContainer>
      <MobileContainer>
        {items.map(({ node }) => (
          <MobileRankingItem key={node.id} rank={node} />
        ))}
      </MobileContainer>
    </React.Fragment>
  )
}
